export interface DeadlineInfo {
    passed: boolean;
    days: number;
    hours: number;
    urgency: 'passed' | 'low' | 'medium' | 'high' | 'critical';
}

export function getDeadlineInfo(deadline: string): DeadlineInfo {
    const now = Date.now();
    const target = new Date(deadline).getTime();
    const diffMs = target - now;

    if (diffMs <= 0) return { passed: true, days: 0, hours: 0, urgency: 'passed' };

    const hours = Math.floor(diffMs / (1000 * 60 * 60));
    const days = Math.floor(hours / 24);

    let urgency: DeadlineInfo['urgency'] = 'low';
    if (hours < 6) urgency = 'critical';
    else if (hours < 24) urgency = 'high';
    else if (days < 3) urgency = 'medium';

    return { passed: false, days, hours, urgency };
}

export const urgencyColors: Record<DeadlineInfo['urgency'], string> = {
    passed: 'text-slate-400',
    low: 'text-slate-500',
    medium: 'text-amber-600',
    high: 'text-orange-600',
    critical: 'text-red-600',
};
